import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handleSpotifyCallback } from '../context/SpotifyContext';
import './SpotifyCallback.css';

export const SpotifyCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const processCallback = async () => {
      const code = searchParams.get('code');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError(`Spotify authentication failed: ${errorParam}`);
        setStatus('error');
        return;
      }

      if (!code) {
        setError('No authorization code received');
        setStatus('error');
        return;
      }

      const success = await handleSpotifyCallback(code);
      
      if (success) {
        setStatus('success');
        // Hard redirect so SpotifyProvider remounts and reloads tokens from localStorage
        const returnUrl = localStorage.getItem('spotify_return_url');
        localStorage.removeItem('spotify_return_url');
        const basePath = process.env.PUBLIC_URL || '';
        const fallbackUrl = `${window.location.origin}${basePath}/prepare`;
        setTimeout(() => {
          window.location.href = returnUrl || fallbackUrl;
        }, 1500);
      } else {
        setError('Failed to complete authentication');
        setStatus('error');
      }
    };

    processCallback();
  }, [searchParams, navigate]);

  return (
    <div className="spotify-callback">
      <div className="callback-card">
        {status === 'processing' && (
          <>
            <div className="spinner"></div>
            <h2>Verbinden met Spotify...</h2>
            <p>Even geduld alsjeblieft</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h2>Verbonden met Spotify!</h2>
            <p>Je wordt doorgestuurd...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="error-icon">✕</div>
            <h2>Verbinding mislukt</h2>
            <p>{error}</p>
            <button onClick={() => navigate('/prepare')}>
              Terug naar Voorbereiding
            </button>
          </>
        )}
      </div>
    </div>
  );
};
